'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M48 160c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 16-144 0c-61.9 0-112 50.1-112 112l0 112-80 0c-8.8 0-16-7.2-16-16l0-224z', 'M176 64l0 32 96 0 0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM128 96l0-32c0-53 43-96 96-96s96 43 96 96l0 32 64 0c35.3 0 64 28.7 64 64l0 16-48 0 0-16c0-8.8-7.2-16-16-16L64 144c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l80 0 0 48-80 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zM256 224l256 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-160c0-35.3 28.7-64 64-64zm80 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 53 43 96 96 96s96-43 96-96l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;